import { isValidElement } from 'react';
import { theme } from 'antd';
import styles from '../style.module.less';
import type { ReactNode } from 'react';
import type { DataNode } from 'antd/es/tree';
import type { TitleRenderData } from './types';

export function useTitleRender(searchValue: string): TitleRenderData {
  const { token } = theme.useToken();
  const titleRender = (treeNode: DataNode): ReactNode => {
    if (isValidElement(treeNode.title)) {
      return treeNode.title;
    }

    const title = treeNode.title as string;
    const isMatched: boolean
      = searchValue !== '' && title.includes?.(searchValue);

    if (isMatched) {
      return <div className={styles.treeHighLight} style={{ color: token.colorPrimary }}>{title}</div>;
    }

    return title;
  };

  return {
    titleRender
  };
}
